import { KNOWLEDGE_BASE, KnowledgeBaseView, type KbCategory } from '@elva/ui';
import { useWorkspaceLabel } from '@elva/platform';
import { useNavigate, useSearchParams } from 'react-router-dom';

/** AI Brain › Knowledge base — add, edit, practice facts (amendment 32 §4). No API — stage's mock. */
export function SettingsKnowledgeBasePage() {
  const location = useWorkspaceLabel();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const question = params.get('question');
  const body = params.get('body');
  const title = params.get('title');
  const entry = params.get('entry');
  const category = params.get('category');

  return (
    <KnowledgeBaseView
      data={KNOWLEDGE_BASE}
      location={location}
      {...(question !== null ? { prefillQuestion: question } : {})}
      {...(body !== null ? { prefillBody: body } : {})}
      {...(title !== null ? { prefillTitle: title } : {})}
      {...(entry !== null ? { prefillEntry: entry } : {})}
      {...(category !== null ? { prefillCategory: category as KbCategory } : {})}
      onOpenTrainElva={() => { void navigate('/settings/ai/train'); }}
      onOpenPracticeManagement={() => { void navigate('/settings/general'); }}
    />
  );
}
